import React from "react";
import { NavLink } from "react-router-dom";

import { FiSettings, FiLogIn, FiHome, FiList } from "react-icons/fi";
import { RiRestaurant2Line } from "react-icons/ri";
import { AiFillCrown } from "react-icons/ai";

import logo from "../../logo.png";
import { Container, Box, Brand, CtaBox, Crown } from "./styles";
import UpgradeCta from "../../Components/UpgradeCta";

export default function SideBar() {
  return (
    <Container className="side-bar">
      <Brand>
        <img src={logo} />
      </Brand>
      <Box>
        <NavLink activeClassName="selected" to="/cardapio">
          <RiRestaurant2Line size="22px" />
          Cardápio
        </NavLink>
        <NavLink activeClassName="selected" to="/establishment">
          <FiHome size="22px" />
          Estabelecimento
        </NavLink>
        <NavLink activeClassName="selected" to="/attendance">
          <FiLogIn size="22px" />
          Config. Atendimento
        </NavLink>
        <a href={`${window.location.origin}/m`} target="_blank">
          <FiList size="22px" />
          Pedidos
          <Crown>
            <span />
            <AiFillCrown style={{ zIndex: 1 }} color="white" size="30px" />
          </Crown>
        </a>
      </Box>
      <CtaBox>
        <>
          <UpgradeCta />
        </>
      </CtaBox>
    </Container>
  );
}
